var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('detail',{attrs:{"base-info":_vm.baseInfo,"data":_vm.data,"statusModule":"rdsBackup","extra-info":_vm.extraInfo,"onManager":_vm.onManager}})}
var staticRenderFns = []

export { render, staticRenderFns }